module.exports = __webpack_public_path__ + "static/media/sapiens.6aa0fb6c.avif";